import React from "react";
import OurGallery from "../../components/user/Gallery/OurGallery";

const Gallery = () => {
  return (
    <div>
      <OurGallery />
    </div>
  );
};

export default Gallery;
